"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Domain = void 0;
const jwtDecode = require("jwt-decode");
const falconone_1 = require("../../private/api-services/falconone");
const phalconone_1 = require("../../private/api-services/phalconone");
const philae_1 = require("../../private/api-services/philae");
const authData_1 = require("../../private/ephemeral/authData");
const property_1 = require("./property");
class Domain {
    constructor() {
        if (!authData_1.Auth.getUserToken()) {
            throw new Error("Cannot use Domain service without authenticated user!, " +
                "please use the Authenticator service first");
        }
        this.falconOne = new falconone_1.FalconOne(authData_1.Auth.getUserToken());
        // deprecated APIs
        this.philae = new philae_1.Philae(authData_1.Auth.getUserToken());
        this.phalconOne = new phalconone_1.PhalconOne(authData_1.Auth.getUserToken(), authData_1.Auth.getDomainToken());
    }
    listUserDomains() {
        return __awaiter(this, void 0, void 0, function* () {
            // return this.philae.get("api/domains");
            const domains = yield this.falconOne.get("domain");
            domains.forEach(d => {
                d.simplifiedProps = property_1.Property.simplifyProps(d.properties);
            });
            return domains;
        });
    }
    createDomain(newDomain) {
        return this.falconOne.post("domain", newDomain);
    }
    getDomain(uuid) {
        // return this.philae.get("api/domains/" + uuid);
        return this.falconOne.get(`domain/${uuid}`);
    }
    openDomain(domainUuid) {
        return new Promise((resolve, reject) => {
            this.falconOne
                .get(`/domain/${domainUuid}/token`)
                .then((token) => {
                authData_1.Auth.setDomainToken(token.domainToken);
                // set domain token
                this.falconOne = new falconone_1.FalconOne(authData_1.Auth.getUserToken(), authData_1.Auth.getDomainToken());
                resolve(token);
            })
                .catch(() => {
                reject(false);
                console.log("Domain authentication failed, user likely does not have access to domain " + domainUuid);
                // throw new Error("domain auth failed");
            });
        });
    }
    prePopulate(domainUuid) {
        return this.falconOne.post("domain/prepopulate", {
            domainUuid
        });
    }
    getCurrentDomain() {
        const domainToken = authData_1.Auth.getDomainToken();
        return (typeof domainToken === 'string') ? jwtDecode(domainToken) : false;
    }
    updateDomain(domain) {
        const domainToken = authData_1.Auth.getDomainToken();
        if (!domainToken) {
            return Promise.reject('updating domain requires domain token (use opendomain first)');
        }
        // @ts-ignore
        const d = jwtDecode(domainToken);
        if (domain.uuid !== d.domainUuid) {
            return Promise.reject('authenticated wrong (use opendomain with this domain first)');
        }
        return this.falconOne.patch(`/domain/${domain.id}`, domain);
    }
    setProperty(domain, key, value, type) {
        const domainToken = authData_1.Auth.getDomainToken();
        if (!domainToken) {
            return Promise.reject('updating domain requires domain token (use opendomain first)');
        }
        // @ts-ignore
        const d = jwtDecode(domainToken);
        if (domain.uuid !== d.domainUuid) {
            return Promise.reject('authenticated wrong (use opendomain with this domain first)');
        }
        return this.falconOne.post(`/domain/${domain.id}/addProperty`, {
            key,
            value,
            type
        });
    }
    saveOnboardingData(ontologySelections) {
        const domainToken = authData_1.Auth.getDomainToken();
        if (!domainToken) {
            return Promise.reject('updating domain requires domain token (use opendomain first)');
        }
        return this.falconOne.post(`/domain/onboardingBatch`, {
            onboardingSequence: ontologySelections
        });
    }
    deleteDomain(domain) {
        const domainToken = authData_1.Auth.getDomainToken();
        if (!domainToken) {
            return Promise.reject('deleting domain requires domain token (use opendomain first)');
        }
        // @ts-ignore
        const d = jwtDecode(domainToken);
        if (domain.uuid !== d.domainUuid) {
            return Promise.reject('authenticated wrong (use opendomain with this domain first)');
        }
        return this.falconOne.delete(`/domain/${domain.id}`);
    }
    getDomainPreviews(domainUuids) {
        return this.falconOne.post(`domain/previews`, { domainUuids });
    }
    // @deprecated
    getDomainStats(domainUuid) {
        return this.falconOne.get(`domain/stats?domainUuid=${domainUuid}`);
    }
    exportDomainData() {
        return this.falconOne.get(`domain/full`);
    }
    getPublicDomains(skip = 0, limit = 0) {
        return this.falconOne.getSearchQuery(`domain/public`, {
            skip,
            limit
        });
    }
    /**
     * Admin endpoints
     *
     * Future - only build with specific version of consumer?
     */
    adminListDomains(pagination = 0, filter = {}, sort = []) {
        // @ts-ignore
        return this.falconOne.getSearchQuery('domain/admin/find', {
            pagination,
            filter,
            sort
        });
    }
    /**
     * the following are to be (re-)created in the future
     * */
    autocomplete(query) {
        return this.phalconOne.getSearchQuery("domain/autocomplete", { q: query });
    }
    nlpQuestion(question, entities) {
        return this.phalconOne.getSearchQuery("domain/question", { question, entities });
    }
    verifyDomain(domainUuid) {
        return this.phalconOne.post("domain/verify", { domainUuid });
    }
    getDomainCollaboration() {
        return this.falconOne.get("domain/collaboration");
    }
    deleteLabelFromDomain(domain, labelId) {
        const domainToken = authData_1.Auth.getDomainToken();
        if (!domainToken) {
            return Promise.reject('deleting domain requires domain token (use opendomain first)');
        }
        // @ts-ignore
        const d = jwtDecode(domainToken);
        if (domain.uuid !== d.domainUuid) {
            return Promise.reject('authenticated wrong (use opendomain with this domain first)');
        }
        return this.falconOne.delete(`domain/${domain.id}/labels/${labelId}`);
    }
}
exports.Domain = Domain;
//# sourceMappingURL=data:application/json;base64,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